module.exports = __webpack_public_path__ + "assets/icons/logo-ie-full-6b7a.svg";